function formatSSN(input) {
  // Remove all non-digit characters
  const digits = input.replace(/\D/g, '');

  if (digits.length <= 3) {
    return digits;
  } else if (digits.length <= 5) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  } else if (digits.length <= 9) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
  }
  // Limit to first 9 digits (valid SSN length)
  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5, 9)}`;
}

function formatEIN(input) {
  // Remove all non-digit characters
  const digits = input.replace(/\D/g, '');

  if (digits.length <= 2) {
    return digits;
  } else if (digits.length <= 9) {
    return `${digits.slice(0, 2)}-${digits.slice(2)}`;
  }
  // Limit to first 9 digits (valid EIN length)
  return `${digits.slice(0, 2)}-${digits.slice(2, 9)}`;
}

export { formatSSN, formatEIN };
